<div class="section-title" [class]="alignment" [class]="theme">
  <span class="subtitle" *ngIf="subtitle">{{ subtitle }}</span>
  <h2 class="title">{{ title }}</h2>
  <div class="decoration"></div>
</div>
